// extracted by mini-css-extract-plugin
export default {"spinner":"TranscriptionChat_spinner__Qhm+2"};